export const AVAILABLE_TYPES = ['image/jpeg', 'image/png']
